import { Fragment } from "react";
import Interactive from "../InteractiveVideo/Interactive";
import PollDisplay from "../LivePoll";
import PollsComponent from "./PollsComponent";
import SpinnerComponent from "./SpinnerComponent";

const VideoFeatures = ({ features, currentTime, videoRef, play, pause }) => {
  return (
    <>
      {features?.map((e, i) => {
        if (e?.typeId === 1) {
          return (
            <Fragment>
              <PollsComponent
                currentTime={
                  currentTime >= e?.startTime + 0.01 &&
                  currentTime <= e?.startTime + e?.duration
                }
                data={e}
                play={play}
                pause={pause}
              />
            </Fragment>
          );
        } else if (e?.typeId === 2) {
          return (
            <Fragment>
              <SpinnerComponent
                currentTime={
                  currentTime >= e?.startTime + 0.01 &&
                  currentTime <= e?.startTime + e?.duration
                }
                data={e}
                play={play}
                pause={pause}
              />
            </Fragment>
          );
        } else if (e?.typeId === 3) {
          return (
            <Fragment>
              <Interactive
                videoRef={videoRef}
                currentTime={
                  currentTime >= e?.startTime + 0.01 &&
                  currentTime <= e?.startTime + e?.duration
                }
                data={e}
                pause={pause}
              />
            </Fragment>
          );
        } else if (e?.typeId === 4) {
          return (
            <Fragment>
              <PollDisplay
                width={1920}
                livePoll={
                  currentTime >= e?.startTime + 0.01 &&
                  currentTime <= e?.startTime + e?.duration
                }
                pollId={e?.entityId}
                pause={pause}
                data={e}
              />
            </Fragment>
          );
        }
      })}
    </>
  );
};

export default VideoFeatures;
